<template>
    <div id="product-listing-element" :class="{empty: !moduleData}">
        <div class="module" v-if="moduleData && moduleData.ProductType" :class="moduleData.Spacing" :id="moduleData.AnchorID">
            <div class="listing-container" v-if="getProductType">
                <div v-if="!getLoadingProducts">
                    <div class="product-categorization">
                        <hr>
                        <div class="left">
                            <div v-if="getCategories && getCategories.length > 1">
                                <label for="category-filter">Category</label>
                                <v-select id="category-filter"
                                          v-model="getProductFilter.category"
                                          :options="getCategories"
                                          :clearable="false"
                                          placeholder="All Categories"
                                          @input="applyFilter(getProducts)">
                                </v-select>
                            </div>
                            <div v-if="getVarieties && getVarieties.length > 1">
                                <label for="variety-filter">Variety</label>
                                <v-select id="variety-filter"
                                          v-model="getProductFilter.variety"
                                          :options="getVarieties"
                                          :clearable="false"
                                          placeholder="All Varieties"
                                          @input="applyFilter(getProducts)">
                                </v-select>
                            </div>
                        </div>
                        <div class="right">
                            <p>{{getFilteredProducts.length}} Items</p>
                            <div>
                                <label for="product-sort">Sort</label>
                                <v-select id="product-sort"
                                          v-model="getProductFilter.sort"
                                          :options="['Most Recent', 'Alphabetical']"
                                          :clearable="false"
                                          @input="applySort(getFilteredProducts)">
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="product-list">
                        <b-row v-if="paginatedProducts.length">
                            <b-col class="product" md="6" lg="4" xl="3" v-for="(item, index) in paginatedProducts" :key="'product' + index"
                                   :style="staggerProducts(index)">
                                <a :href="item.Link">
                                    <div class="tags" v-if="item.Tags">
                                        <div class="tag" v-for="(tag,index) in item.Tags" :class="tag.ColourClass">
                                            <p>
                                                <span :class="{small: tag.Subtitle}">{{tag.Title}}</span>
                                                <span class="large" v-if="tag.Subtitle">{{tag.Subtitle}}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <img v-if="item.Image && item.Image.ID" :src="item.Image.URL"/>
                                    <div class="description">
                                        <p class="name">{{item.Title}}</p>
                                        <p v-if="item.StartTime">From: {{ item.StartTime | date }}</p>
                                        <p v-if="item.EndTime">To: {{ item.EndTime | date }}</p>
                                        <p class="price" v-if="item.LocalisedPrice > 0">${{item.LocalisedPrice.toFixed(2)}}</p>
                                    </div>
                                </a>
                            </b-col>
                        </b-row>
                        <div class="empty" v-else><p>No products found, try filtering the products differently.</p></div>
                    </div>
                    <button class="btn" v-if="showLoadMore" @click="loadMore">Load More</button>
                </div>
                <div class="loading" v-else></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import moment from 'moment';

    export default {
        name: "EventListingElement",
        props: {
            component: {
                type: Object,
            }
        },
        filters: {
            date(val) {
                return val ? moment(val).format("MMMM Do YYYY, h:mm a") : "";
            }
        },
        computed: {
            ...mapGetters(['getModuleData', 'getProductType', 'getLoadingProducts', 'getProducts', 'getFilteredProducts', 'getCategories', 'getVarieties', 'getProductFilter', 'getProductLimit']),
            showLoadMore() {
                return this.getProductLimit < this.getFilteredProducts.length;
            },
            paginatedProducts() {
                let limit = this.getProductLimit;
                return this.getFilteredProducts.slice(0, parseFloat(limit));
            },
            moduleData() {
                let data = this.getModuleData(this.component.ID);
                if (data && data.ProductType && !this.getProductType) {
                    //set page size
                    let pageSize = data.PageSize;
                    if (pageSize > 4) {
                        this.setProductPageSize(data.PageSize);
                    }

                    //set product type
                    this.setProductType(data.ProductType);
                }
                return data;
            }
        },
        methods: {
            ...mapActions(['setProductType', 'setProductPageSize', 'applyFilter', 'applySort', 'loadMore']),
            staggerProducts(index) {
                return {'--animation-order': index}
            }
        }
    }
</script>
